/**
 * KYB contract gate notice (docs/decisions/kyb.md "Contract gate").
 *
 * A contract becomes binding when both owners accept it, and both companies
 * should be verified by then. In `warn` mode the contract goes through with
 * these warnings; in `enforce` mode acceptance is refused until they clear
 * (or a super moderator records an override). Messages come from the backend.
 */
import { useTranslation } from "react-i18next";
import type { KybWarning } from "../../config/api";
import "./KybFlow.css";

const KybGateNotice = ({
  warnings,
  blocked = false,
  showVerdict = false,
}: {
  warnings: KybWarning[];
  blocked?: boolean;
  showVerdict?: boolean;
}) => {
  const { t } = useTranslation("kyb");
  if (warnings.length === 0) return null;
  return (
    <div className={`kyb-gate ${blocked ? "kyb-gate--blocked" : ""}`} role={blocked ? "alert" : "status"}>
      <strong>
        <i className="fa-solid fa-shield-halved" /> {blocked ? t("gate.blockedTitle") : t("gate.warningTitle")}
      </strong>
      <ul>
        {warnings.map((w) => (
          <li key={`${w.side}-${w.companyId}`}>
            {w.message}
            {showVerdict && w.verdict ? ` (${t("gate.verdict", { verdict: w.verdict })})` : ""}
          </li>
        ))}
      </ul>
      <p>{blocked ? t("gate.blockedHelp") : t("gate.warningHelp")}</p>
    </div>
  );
};

export default KybGateNotice;
